<div>
    <h5 mat-dialog-title class="modal_title text-[#0b0b13] text-[15px] leading-normal font-medium mt-0 flex w-full">
        {{_customFieldSer?.typeOf == 'add' ? ('EMAIL_MARKETING.CREATE_CUSTOM_FIELD' | translate) : ('SETTING_PAGE.EDIT_CUSTOM_FIELD' | translate)}}
        <i class="ri-close-fill ml-auto text-[22px] leading-none cursor-pointer font-medium text-[#0b0d13]"
            mat-dialog-close></i>
    </h5>
    <form [formGroup]="_customFieldSer?.customFieldForm">
        <mat-dialog-content class="modal_body">
            <div class="mail-name-input form-group relative mb-4">
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" floatLabel="always">
                    <mat-label class="form_label">{{"EMAIL_MARKETING.FIELD_NAME" | translate}}</mat-label>
                    <input #focusInput type="text" id="name" required class="w-full form_input rounded-3" [autofocus]
                        [class]="_customFieldSer?.typeOf == 'update' ? 'cursor-not-allowed' : ''"
                        [readonly]="_customFieldSer?.typeOf == 'update' ? true : false"
                        [placeholder]="'EMAIL_MARKETING.ENTER_FIELD_NAME' | translate" formControlName="name" matInput
                        autocomplete="off" />
                        <mat-error *ngIf="_customFieldSer?.customFieldForm?.get('name')?.touched && _customFieldSer?.customFieldForm?.get('name')?.errors?.required">{{"EMAIL_MARKETING.FIELD_REQUIRED" | translate}}</mat-error>
                    <mat-hint class="mat-error"
                        *ngIf="_customFieldSer?.customFieldForm?.controls?.name?.errors?.lv">{{_customFieldSer?.customFieldForm?.controls?.name?.getError("lv")}}</mat-hint>
                </mat-form-field>
            </div>
            <div class="mail-name-input form-group relative mb-4">
                <div>
                    <mat-label class="text-[#0b0d13] font-normal text-base leading-[18px]"
                        (click)="visibility.open()">{{"EMAIL_MARKETING.VISIBLE" | translate}}<span
                            class="text-red-500">*</span><i
                            class="ri-information-line ml-1 text-[#2D3347] absolute top-1 cursor-pointer"
                            [tooltip]='"EMAIL_MARKETING.VISIBILITY_TOOLTIP" | translate' placement="right"
                            [zIndex]="1160">
                        </i>
                    </mat-label>
                    <mat-form-field class="w-full fuse-mat-dense mt-[3px]" subscriptSizing="dynamic"
                        floatLabel="always">
                        <mat-select #visibility formControlName="isVisible" name="isVisible">
                            <mat-option [value]="'visible'">{{"EMAIL_MARKETING.VISIBLE" | translate}}</mat-option>
                            <mat-option [value]="'invisible'">{{"EMAIL_MARKETING.INVISIBLE" | translate}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="_customFieldSer?.customFieldForm?.get('isVisible')?.touched && _customFieldSer?.customFieldForm?.get('isVisible')?.errors?.required">{{"EMAIL_MARKETING.FIELD_REQUIRED" | translate}}</mat-error>
                        <mat-hint class="mat-error"
                            *ngIf="_customFieldSer?.customFieldForm?.controls?.isVisible?.errors?.lv">{{_customFieldSer?.customFieldForm?.controls?.isVisible?.getError("lv")}}</mat-hint>
                    </mat-form-field>
                </div>
            </div>
            <div class="mail-name-input form-group relative">
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" floatLabel="always">
                    <mat-label class="form_label">{{"EMAIL_MARKETING.FALLBACK_TEXT" | translate}}
                        <i class="ri-information-line absolute ml-1 mt-[1px] text-[#2D3347] cursor-pointer"
                            [tooltip]='"EMAIL_MARKETING.FALLBACK_TEXT_TOOLTIP" | translate' placement="right"
                            [zIndex]="1160">
                        </i>
                    </mat-label>
                    <input type="text" id="fallbackText" class="w-full form_input rounded-3"
                        [placeholder]="'EMAIL_MARKETING.ENTER_FEEDBACK_TEXT' | translate" formControlName="fallbackText"
                        matInput autocomplete="off" />
                        <mat-hint class="mat-error"
                        *ngIf="_customFieldSer?.customFieldForm?.controls?.fallbackText?.errors?.lv">{{_customFieldSer?.customFieldForm?.controls?.fallbackText?.getError("lv")}}</mat-hint>
                </mat-form-field>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="start" class="form_action">
            <btn-loading type="submit" color="primary"
                (click)="_customFieldSer?.typeOf == 'add' ? addCustomField() : updateCustomField()"
                [loading]="_customFieldSer?.typeOf == 'add' ? isAddField : isUpdateField"
                btnClass="text-custom text-md font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded">{{(_customFieldSer?.typeOf == 'add' ?
                'GENERAL.SAVE' : 'CAMPAIGN.UPDATE') | translate}}</btn-loading>
            <button *ngIf="!isAddField || !isUpdateField" matRipple class="cancel_btn" mat-dialog-close>{{
                "GENERAL.CANCEL" | translate
                }}</button>
        </mat-dialog-actions>
    </form>
</div>
